import { useEffect, useRef, useState } from "react";

export const buttonGlobalStyles = {
      // backgroundColor: '#b7b4c5',   
      backgroundColor: 'var(--color-26)',
      color: 'white',
      border: 'none',
      padding: '10px 20px',
      cursor: 'pointer',
      borderRadius: '0.3em',
      transition: 'background-color 0.3s ease',  
      
      '&:hover': {
        // backgroundColor: '#9ab7b2',
       backgroundColor: '#7b7b6a',
        cursor: 'pointer',
      },  
  };
  

// export const useFadeInOnScroll = () => {
//   const ref = useRef();

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           entry.target.classList.add("show");
//         }
//       },
//       {
//         threshold: 0.1,
//         rootMargin: "0px 0px -100px 0px",
//       }
//     );

//     if (ref.current) observer.observe(ref.current);

//     return () => {
//       if (ref.current) observer.unobserve(ref.current);
//     };
//   }, []);

//   return ref;
// };

export const useFadeInOnScroll = (deps = []) => {
  const ref = useRef(null);
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(false);
    if (ref.current) {
      ref.current.classList.remove('show');
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px",
      }
    );

    const node = ref.current;
    if (node) observer.observe(node);

    return () => {
      if (node) observer.unobserve(node);
    };
  }, deps);

  useEffect(() => {
    if (isVisible && ref.current) {
      ref.current.classList.add("show");
    }
  }, [isVisible]);

  return ref;
};


export const iconSidebar = {
  marginLeft: 0,
   color:'#fff',
   alignItems: 'center',
   justifyContent: 'center',
   alignSelf: 'center',
  '&:hover': {
    color:'#405b3c',
    //backgroundColor: '#fff',
    borderRadius: '30%',
    transition: 'background-color 0.3s ease',
},};

export const listItemButtonSidebar = (open) => ({
    gap: '0.5em',
    justifyContent: open ? 'flex-start' : 'center',
    padding: open ? '0px 4px' : '2px 6px',
    marginY: open ? 0.3 : 0.2,
    marginX: open ? 0.6 : 0.3,
    transition: 'background-color 0.3s ease, color 0.3s ease',
    '&:hover': {
      color: '#405b3c',
      backgroundColor: '#d8d8ba',
      borderRadius: '4px',
    },
    '&:hover .MuiSvgIcon-root': {
    color: '#405b3c',
    },
    '&.Mui-selected': {
      color: '#405b3c',
      backgroundColor: '#d6d6c6',  
      borderRadius: '4px',        
    },
    '&.Mui-selected .MuiSvgIcon-root': {
        color: '#405b3c',
      },
      '&.Mui-selected:hover': {
        color: '#405b3c',
        backgroundColor: '#d8d8ba', 
        borderRadius: '4px',       
    },
    
   '&:hover .MuiListItemText-root .MuiTypography-root': {
    // fontWeight: 600,
    // fontFamily: "'Raleway', 'Nunito', sans-serif",
  },
   
  });

export const listItemButtonSidebarSubmenu = (open) => ({
  flexDirection: open ? 'row' : 'column',
  alignItems: 'center',
  justifyContent: open ? 'space-between' : 'center',
  color: '#25262A',
  gap: open ? 1 : 0,
  padding: '2px 6px',
  // marginY: open ? 0.3 : 0.2,
  marginX: open ? 0.6 : 0.3,
  '&:hover': {
    color: '#405b3c',
    backgroundColor: '#d8d8ba',
    borderRadius: '4px',
  },
  '&:hover .MuiSvgIcon-root': {
    color: '#405b3c',
  },
  '&:hover .MuiListItemText-root .MuiTypography-root': {
    color: '#405b3c',
  },
});

export const textForm = {
    fontFamily: "'Nunito', sans-serif",
    fontWeight: '500',
  }

export const buttonStandard =  {
    fontFamily: 'Nunito, san-serif',
    color: '#ffffff',
    fontWeight: '500',
    textTransform: 'none',
    backgroundColor: 'rgba(135, 120, 135, 0.72)',
    borderRadius: '5px',
    width:'max-content',
    alignSelf: 'center',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease, transform 0.3s ease',
      '&:hover': {
        backgroundColor: 'rgb(107, 107, 107)',
        cursor: 'pointer',
      }

 }

export const iconStandard = (theme) => ({
  color: theme.palette.tertiary.main,

});
